import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import * as actions from '../actions/TablaMovimientosMercaderiaActions'
import { connect } from 'react-redux'
import moment from 'moment'
import EditIcon from '@material-ui/icons/Edit'
import { Dialog } from '@material-ui/core'
import { toast, ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../../config/settings'
import { FORM_TAREA_MOVIMIENTO } from '../../../../../config/forms'
import { reduxForm, formValueSelector } from 'redux-form'
import DialogoTareasUpdate from '../components/DialogoTareasUpdate'

const selector = formValueSelector(FORM_TAREA_MOVIMIENTO)

function EdicionTareasMovimientoPendiente (props) {
  const { fechaRegistroTarea } = props

  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    updateState()
  }

  const handleSubmit = ({ finalizada }) => {
    const { tarea, fechaInicio, horaInicio, fechaFin, horaFin, toneladas } = props
    console.log('finalizada', finalizada)

    const fInicio = moment(fechaInicio + ' ' + horaInicio).format('YYYY-MM-DD HH:mm:ss')

    if (fechaFin && horaFin) {
      if (toneladas && toneladas > 0) {
        const fFin = moment(fechaFin + ' ' + horaFin).format('YYYY-MM-DD HH:mm:ss')
        props.finalizarTareaPendiente(fechaRegistroTarea, tarea, fInicio, fFin, toneladas)
        console.log('edito tarea:', tarea, fInicio, fFin, toneladas)
        handleClose()
      } else {
        toast.error('El valor de toneladas es incorrecto.')
      }
    } else {
      console.log('edito tarea sin finalizar:', tarea, fInicio)
      props.updateTareaPendiente(fechaRegistroTarea, tarea, fInicio)
      handleClose()
    }
  }

  const updateState = () => {
    const { change: formChange } = props
    formChange('tarea', '')
    formChange('fechaInicio', (moment().format('YYYY/MM/DD')))
    formChange('horaInicio', moment().format('HH:mm'))
    formChange('fechaFin', null)
    formChange('horaFin', null)
    formChange('toneladas', null)
  }

  function onClick () {
    handleOpen()
  }

  return (
    <div>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth='xs'>
          <DialogoTareasUpdate fechaRegistroTarea={fechaRegistroTarea} handleClose={handleClose} handleSubmit={handleSubmit} />
        </Dialog>
        <div>
          <Tooltip title={'Editar'}>
            <IconButton onClick={onClick}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    tarea: selector(state, 'tarea'),
    fechaInicio: selector(state, 'fechaInicio'),
    horaInicio: selector(state, 'horaInicio'),
    fechaFin: selector(state, 'fechaFin'),
    horaFin: selector(state, 'horaFin'),
    toneladas: selector(state, 'toneladas')
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_TAREA_MOVIMIENTO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(EdicionTareasMovimientoPendiente))
